import { CreatorShopFundingsPage } from './CreatorShopFundingsPage.ts';

export const creatorShopFundingsRouter = {
  '/fundings': CreatorShopFundingsPage,
};
